/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nav[_ngcontent-%COMP%]{padding:20px;-webkit-box-shadow:1px 0 5px rgba(0,0,0,.1);box-shadow:1px 0 5px rgba(0,0,0,.1);margin:0 0 12px -11px;background-color:#fff}.nav[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:22px;color:#41abf3}.nav[_ngcontent-%COMP%]   div[nav][_ngcontent-%COMP%]{margin-top:4px;font-size:14px;color:#67757c}.nav[_ngcontent-%COMP%]   div[nav][_ngcontent-%COMP%]   span[link][_ngcontent-%COMP%]{cursor:pointer;color:#41abf3}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/nav/hub.nav.component.scss.shim.ngstyle.js.pre-build-optimizer.js